(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pro-sock-checkout-reminder"] && !Shopify.designMode) return;
  try {
    (() => {
  const reminder = document.getElementById('ProSockCheckoutReminder');
  if (!reminder || reminder.dataset.initialized === 'true') return;

  reminder.dataset.initialized = 'true';

  const eligibleHandles = new Set(
    reminder.dataset.eligibleHandles.split(',').map((handle) => handle.trim()).filter(Boolean)
  );
  const checkoutSelector =
    'button[name="checkout"], input[name="checkout"], #CartDrawer-Checkout, a[href*="/checkout"]';
  const onePairMessage = reminder.querySelector('[data-reminder-message-one]');
  const twoPairMessage = reminder.querySelector('[data-reminder-message-two]');
  const continueButton = reminder.querySelector('[data-reminder-continue]');
  let pendingTrigger = null;
  let previousFocus = null;
  let checkingCart = false;
  let bypassReminder = false;

  const closeReminder = () => {
    reminder.hidden = true;
    document.body.style.overflow = '';
    pendingTrigger = null;

    if (previousFocus instanceof HTMLElement) {
      previousFocus.focus();
    }
  };

  const showReminder = (quantity, trigger) => {
    pendingTrigger = trigger;
    previousFocus = document.activeElement;
    onePairMessage.hidden = quantity !== 1;
    twoPairMessage.hidden = quantity !== 2;
    reminder.hidden = false;
    document.body.style.overflow = 'hidden';
    continueButton.focus();
  };

  const continueToCheckout = (trigger) => {
    if (!trigger) return;

    bypassReminder = true;
    reminder.hidden = true;
    document.body.style.overflow = '';

    if (trigger instanceof HTMLAnchorElement) {
      window.location.assign(trigger.href);
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(`${root}checkout`);
  };

  const eligibleQuantity = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Cart request failed');

    const cart = await response.json();

    return cart.items.reduce((total, item) => {
      return eligibleHandles.has(item.handle) ? total + item.quantity : total;
    }, 0);
  };

  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest(checkoutSelector);

      if (!trigger || reminder.contains(trigger) || bypassReminder) return;
      if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (checkingCart) return;
      checkingCart = true;

      try {
        const quantity = await eligibleQuantity();

        if (quantity === 1 || quantity === 2) {
          showReminder(quantity, trigger);
        } else {
          continueToCheckout(trigger);
        }
      } catch (error) {
        continueToCheckout(trigger);
      } finally {
        checkingCart = false;
      }
    },
    true
  );

  reminder.querySelectorAll('[data-reminder-close]').forEach((button) => {
    button.addEventListener('click', closeReminder);
  });

  continueButton.addEventListener('click', () => {
    continueToCheckout(pendingTrigger);
  });

  reminder.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeReminder();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      reminder.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter((element) => !element.hidden);

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pro-sock-multipair-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const initMultipairSelector = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const scope = root.closest('product-info') || root.closest('.product') || document;
    const packs = Array.from(root.querySelectorAll('[data-pro-sock-pack]'));
    const builder = root.querySelector('[data-pro-sock-builder]');
    const rows = root.querySelector('[data-pro-sock-rows]');
    const status = root.querySelector('[data-pro-sock-status]');
    const variantData = root.querySelector('[data-pro-sock-variant-data]');
    const form = scope.querySelector('product-form form') || scope.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const quantityInput = scope.querySelector('input[name="quantity"]');
    const quantityBlock = quantityInput?.closest('.product-form__quantity');
    const nativeVariantPicker = scope.querySelector('variant-selects, variant-radios');
    const paymentButton = scope.querySelector('.shopify-payment-button');
    const submitButton = form?.querySelector('[name="add"]');
    const submitLabel = submitButton?.querySelector('span') || submitButton;
    const locale = (document.documentElement.lang || 'sv-SE').toLowerCase();
    const isSwedish = locale.startsWith('sv');
    let variants = [];
    let activePack = 1;
    let adding = false;

    try {
      variants = JSON.parse(variantData?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const availableVariants = variants.filter((variant) => variant.available !== false);
    const variantPrices = new Map(variants.map((variant) => [String(variant.id), Number(variant.price)]));
    const currency = window.Shopify?.currency?.active || 'SEK';

    const formatMoney = (cents) => {
      const roundedCents = Math.round(Number(cents) || 0);
      const hasDecimals = roundedCents % 100 !== 0;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2,
      }).format(roundedCents / 100);
    };

    const selectedUnitPrice = () => {
      const selectedId = String(variantInput?.value || '');
      return variantPrices.get(selectedId) || Number(availableVariants[0]?.price || variants[0]?.price || 0);
    };

    const updatePrices = () => {
      const unitPrice = selectedUnitPrice();
      if (!unitPrice) return;

      root.querySelectorAll('[data-pro-sock-total]').forEach((element) => {
        const quantity = Number(element.dataset.quantity || 1);
        const discount = Number(element.dataset.discount || 0);
        element.textContent = formatMoney(unitPrice * quantity * (100 - discount) / 100);
      });

      root.querySelectorAll('[data-pro-sock-save]').forEach((element) => {
        const quantity = Number(element.dataset.quantity || 1);
        const discount = Number(element.dataset.discount || 0);
        const prefix = isSwedish ? 'Spara' : 'Save';
        element.textContent = `${prefix} ${formatMoney(unitPrice * quantity * discount / 100)}`;
      });
    };

    const setHidden = (element, hidden) => {
      if (!element) return;
      element.hidden = hidden;
      element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    };

    const createVariantRows = (quantity) => {
      if (!rows) return;
      const previousIds = Array.from(rows.querySelectorAll('[data-pro-sock-pair-variant]')).map((select) => select.value);
      const defaultId = String(variantInput?.value || availableVariants[0]?.id || '');
      rows.replaceChildren();

      for (let index = 0; index < quantity; index += 1) {
        const row = document.createElement('label');
        row.className = 'pro-sock-multipair__row';

        const rowLabel = document.createElement('span');
        rowLabel.className = 'pro-sock-multipair__row-label';
        rowLabel.textContent = isSwedish ? `Par ${index + 1}` : `Pair ${index + 1}`;

        const select = document.createElement('select');
        select.className = 'pro-sock-multipair__select';
        select.setAttribute('data-pro-sock-pair-variant', '');
        select.setAttribute('aria-label', isSwedish ? `Storlek och färg för par ${index + 1}` : `Size and colour for pair ${index + 1}`);

        availableVariants.forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.public_title || variant.title;
          select.append(option);
        });

        const preferredId = previousIds[index] || defaultId;
        if (availableVariants.some((variant) => String(variant.id) === preferredId)) select.value = preferredId;

        row.append(rowLabel, select);
        rows.append(row);
      }
    };

    const updateSubmitLabel = () => {
      if (!submitLabel) return;
      if (!submitLabel.dataset.proSockDefault) submitLabel.dataset.proSockDefault = submitLabel.textContent.trim();

      if (activePack === 3 || activePack === 6) {
        submitLabel.textContent = isSwedish
          ? `Lägg ${activePack} par i varukorgen`
          : `Add ${activePack} pairs to cart`;
      } else {
        submitLabel.textContent = submitLabel.dataset.proSockDefault;
      }
    };

    const applyPack = (quantity) => {
      activePack = Number(quantity) || 1;
      const isMixedPack = activePack === 3 || activePack === 6;
      root.dataset.activePack = String(activePack);
      if (status) status.textContent = '';

      if (quantityInput) {
        quantityInput.value = String(activePack);
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (builder) builder.hidden = !isMixedPack;
      setHidden(nativeVariantPicker, isMixedPack);
      setHidden(quantityBlock, isMixedPack);
      setHidden(paymentButton, isMixedPack);

      if (isMixedPack) createVariantRows(activePack);
      updateSubmitLabel();
    };

    packs.forEach((pack) => {
      pack.addEventListener('change', () => {
        if (pack.checked) applyPack(pack.value);
      });
    });

    quantityInput?.addEventListener('change', () => {
      const quantity = Number(quantityInput.value || 1);
      const matchingPack = packs.find((pack) => Number(pack.value) === quantity);
      packs.forEach((pack) => { pack.checked = pack === matchingPack; });

      if (matchingPack && quantity !== activePack) applyPack(quantity);
      if (!matchingPack && activePack !== quantity) {
        activePack = quantity;
        if (builder) builder.hidden = true;
        setHidden(nativeVariantPicker, false);
        setHidden(quantityBlock, false);
        setHidden(paymentButton, false);
        updateSubmitLabel();
      }
    });

    scope.addEventListener('change', () => window.setTimeout(updatePrices, 0));

    form?.addEventListener('submit', async (event) => {
      if (activePack !== 3 && activePack !== 6) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (adding) return;

      const selectedIds = Array.from(rows?.querySelectorAll('[data-pro-sock-pair-variant]') || []).map((select) => select.value);
      if (selectedIds.length !== activePack || selectedIds.some((id) => !id)) {
        if (status) status.textContent = isSwedish ? 'Välj storlek och färg för alla par.' : 'Choose a size and colour for every pair.';
        return;
      }

      const quantities = selectedIds.reduce((result, id) => {
        result[id] = (result[id] || 0) + 1;
        return result;
      }, {});
      const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));

      adding = true;
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('loading');
      }
      if (status) status.textContent = isSwedish ? 'Lägger till valda par…' : 'Adding selected pairs…';

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Cart error');
        }

        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        adding = false;
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.classList.remove('loading');
        }
        if (status) status.textContent = isSwedish
          ? 'Något gick fel. Kontrollera valen och försök igen.'
          : 'Something went wrong. Check your selections and try again.';
      }
    }, true);

    updatePrices();
    applyPack(1);
  };

  const initAllMultipairSelectors = (container = document) => {
    container.querySelectorAll('[data-pro-sock-multipair]').forEach(initMultipairSelector);
  };

  initAllMultipairSelectors();
  document.addEventListener('DOMContentLoaded', () => initAllMultipairSelectors());
  document.addEventListener('shopify:section:load', (event) => initAllMultipairSelectors(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
